import { gql } from 'react-apollo';

export default gql`
  query offerAnon($_id: ID!, $tenantId: ID!) {
    offerAnon(_id: $_id, tenantId: $tenantId) {
      _id
      name
      status
      visibility
      countDown
      headerImageUrl
      offerPresentationTitle
      offerPresentationUrl
      stripeAccountId
      stripeProductId
      enableOfferPresentation
      headerType
      headerVideoId
      listingType
      sector
      investmentInstrument
      area
      typeOfOffer
      repName
      crdNumber
      minimumInvestment
      offerPassword
      targetRaise
      offerCurrency
      valueRange
      assetStatus
      sharesForSale
      highlights
      primaryObjective
      netAcres
      county
      averageDailyProduction
      approved
      valuationCap
      maturity
      coupon
      discountRate
      baseCurrency
      geographicMandate
      fundType
      domicileOption
      domicileOnshore
      domicileOnshoreFund_other
      domicileOffShore
      domicileOffShore_other
      systematicDiscretionaryOption
      investmentCoActExemptionOption
      investmentAdvisorType
      leverage
      fundStrategyClassfication
      fundStrategyClassficationOne
      fundStrategyClassficationTwo
      fundStrategyClassficationThree
      aumfund
      fundCapacity
      trackRecordFund
      trackRecordFirm
      testWatersToggle

      toggleDataRoom
      dataRoomId
      dataRoomGroupId
      dataRoomCreated

      altOfferTitle

      documents {
        _id
        title
        url
        previewImageUrl
      }
      videoFiles {
        _id
        title
        url
        imageUrl
      }
      faqs {
        _id
        question
        answer
      }

      videoUrls

      issuerCompany {
        _id
        name
        logoUrl
        companyBackground
        isCompanyApproved
        users {
          _id
          fullName
          position
          biography
          isManagementUserApproved
          imageUrl
          order
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/offerAnon.js